const FilterSelect = ({ value, onChange, options = [], label = 'All', ariaLabel, className = '' }) => (
  <select
    className={`form-select form-select-sm w-auto min-w-24 ${className}`}
    value={value}
    aria-label={ariaLabel || label}
    onChange={(event) => onChange(event.target.value)}
  >
    <option value="">{label}</option>
    {options.map((option) => {
      const key = typeof option === 'string' ? option : option.value;
      const text = typeof option === 'string' ? option : option.label;
      return (
        <option key={key} value={key}>
          {typeof option === 'string' ? text.charAt(0).toUpperCase() + text.slice(1) : text}
        </option>
      );
    })}
  </select>
);

export default FilterSelect;
